export const FILTER_TYPE = {
  Purchases: 'purchase',
  CryptoPurchases: 'CRYPTO',
  Withdrawals: 'Redeem',
  PvP: 'PvP',
  FP: 'FastPlay',
};
